// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import commonStyles from "assets/jss/common/common.jsx";
import classNames from "classnames";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import React, { memo, useLayoutEffect, useRef, useEffect } from "react";
import Anime, { anime } from 'react-anime';
import { useHistory, useLocation } from "react-router-dom";
import scrollToComponent from 'react-scroll-to-component';
// nodejs library that concatenates classes
import { isMobile, width as screenWidth, isExtraLarge, isLarge } from "Utils/Dimension";
import ReadyToInvest from 'views/Sections/ReadyToInvest';
import SectionBanner from "views/Sections/SectionBanner.jsx";
import SectionCards from "views/Sections/SectionCards.jsx";
import SectionContactUs from "views/Sections/SectionContactUs.jsx";
import SectionNews from "views/Sections/SectionNews.jsx";
import ThemeFactorTitle from 'views/Sections/ThemeFactorTitle';
import { themes } from 'views/Sections/Themes/theme_demo';

import Carousel from "react-slick";
import ThematicDescription from 'views/Sections/Description/ThematicDescription';
import SectionThemes from "views/Sections/Themes/SectionThemes";
import themegraphdata from 'views/DemoData/ThemeData/';
import FactorDescription from 'views/Sections/Description/FactorDescription';
import { is_production } from 'config'
import SearchBox from 'components/Header/SearchBox'
import SectionServices from "views/Sections/SectionServices";
import { Box } from '@material-ui/core'
import SectionAboutUs from "views/Sections/SectionAboutUs";
import StructuralThemesComponent from "views/Sections/Themes/StructuralThemesComponent";
import { Container, Button } from "@mui/material";
import thematicImg from "assets/img/thematic-analysis-sample.png"
import colorStyle from "assets/jss/common/colorStyle";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt'

const documentLink = 'https://actelligentassets.s3.eu-west-2.amazonaws.com/Actelligent+Capital+Management+Limited_Type+4+and+Type+9+Licenses+(BOG820)_062419+(002).pdf'

const styles = {
  ...commonStyles,
  company_photo: {
    width: isMobile ? 130 : 200,
    height: isMobile ? 130 : 200,
    borderRadius: '50%'
  },
  company_photo_shadow: {
    position: 'relative',
    left: isMobile ? 50 : 80,
    top: isMobile ? -80 : -100,
    width: isMobile ? 100 : 150,
    height: isMobile ? 100 : 150,
    borderRadius: '50%',
    opacity: 0.3
  },
  profile_title: {
    color: 'white',
    paddingTop: '2em',
    textAlign: 'left'
  }
}
function devideThemes(mainthemeTitles) {
  const mainThemes = [], otherThemes = [];
  themes.forEach(element => {
    if (mainthemeTitles.indexOf(element.title) > -1) {
      mainThemes.push(element)
    } else {
      otherThemes.push(element)
    }
  });
  return {
    mainThemesold: mainThemes,
    otherThemesold: otherThemes
  }
}
function LandingPage(props) {

  const { otherThemesold } = devideThemes(['eSports',
    'High-end Android Smartphones',
    'iPhone', '3D Sensing', '5G',
    'Semis by Different Application',
    'Tech by End Markets', 'Industrial Automation'])
  const { classes } = props;

  let thematicInvestRef = useRef();
  let factorInvestRef = useRef();
  let carouselRef = useRef();
  let location = useLocation();
  const history = useHistory();

  useLayoutEffect(() => {
    setTimeout(() => {

      scroll()
    }, 100);
  }, [location])

  const scroll = () => {
    const urlParams = new URLSearchParams(location.search);
    const scrollTo = urlParams.get('scrollTo')
    if (scrollTo) {
      switch (scrollTo) {
        case 'thematic_investing':
          scrollToComponent(thematicInvestRef, { offset: -screenWidth * 0.06, align: 'top', duration: 500, ease: 'inCirc' })

          break;
        case 'factor_investing':
          scrollToComponent(factorInvestRef, { offset: -screenWidth * 0.06, align: 'top', duration: 500, ease: 'inCirc' })
          break;

        default:
          document.getElementById(scrollTo).scrollIntoView({
            behavior: 'smooth'
          })

          break;
      }
    }

  }

  return (
    <div style={{ paddingBottom: '3rem' }}>
      <Parallax image={require("assets/img/hero-bg.jpg")} filter="dark" styles={{ paddingBottom: 50 }}>

        <div className={classes.container}>
          <div className={classes.content}>
            <GridContainer style={{ paddingTop: isMobile ? '30%' : '20vh', textAlign: 'center', }}>
              <GridItem xs={12} sm={12} md={12}>
                <div>
                  {isMobile && <><h2 className={classes.h1 + ' ' + classes.fontBold + ' ' + classes.white + ' ' + classes.textCenter}>
                  ACTELLIGENTによって<br />投資のポテンシャル<br />を開放しましょう
                  </h2>
                  <h3 className={classes.white}>
                    {/* <i>Actelligent is a tech-enabled asset management platform</i> */}
                    AIの力によって<span><u>テーマ</u></span>投資と<br /><span><u>ファクター</u></span>投資を活用
                  </h3>
                  <Box>
                    <Button href="https://www.actelligent-capital.com/services" variant="contained" size="large" sx={{ backgroundColor: colorStyle.infoColor, mt: '1.5rem', fontSize: '1.2rem', color: 'white', "&:hover": { backgroundColor: '#007887' }}}>さらに詳しく見る <ArrowRightAltIcon /></Button>
                  </Box>
                  </>}

                  {!isMobile && <><h3 className={classes.h1 + ' ' + classes.fontBold + ' ' + classes.white + ' ' + classes.textCenter}>
                  ACTELLIGENTによって<br />投資のポテンシャルを開放しましょう
                  </h3>
                  <h3 className={classes.white}>
                    {/* <i>Actelligent is a tech-enabled asset management platform</i> */}
                    AIの力によって<span style={{ fontSize: '1.7rem' }}><u>テーマ</u></span>投資と<span style={{ fontSize: '1.7rem' }}><u>ファクター</u></span>投資を活用
                  </h3>
                  <Box>
                    <Button href="https://www.actelligent-capital.com/services" variant="contained" size="large" sx={{ backgroundColor: colorStyle.infoColor, mt: '1.5rem', fontSize: '1.2rem', color: 'white', "&:hover": { backgroundColor: '#007887' }}}>さらに詳しく見る <ArrowRightAltIcon /></Button>
                  </Box></>}
                  
                </div>
              </GridItem>
            </GridContainer>
          </div>

        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>


        {/* <SectionCards /> */}
        {/* <SectionStrategy {...rest}></SectionStrategy> */}

        {/* <SectionPartnership {...rest} /> */}
        {/* <SectionProduct /> */}
        {/* <div className={classes.section}>
        <div className={classes.container}>
            {isMobile && <h3 className={classes.h3 + " " + classes.textCenter + ' ' + classes.fontBold}><span className={classes.info}>データサイエンス</span>
            と<span className={classes.info}>投資</span>が交わる場所</h3>}

            {!isMobile && <h3 className={classes.h1 + " " + classes.textCenter + ' ' + classes.fontBold}><span className={classes.info}>データサイエンス</span>
            と<span className={classes.info}>投資</span>が交わる場所</h3>}

            {isMobile && <h3 className={classes.h5 + " " + classes.textCenter + ' ' + classes.fontBold} style={{ marginBottom: 'rem' }}>
            AIの力で<span className={classes.info}>テーマ</span>投資と<span className={classes.info}>ファクター</span>投資を融合
            </h3>}

            {!isMobile && <h3 className={classes.h3 + " " + classes.textCenter + ' ' + classes.fontBold} style={{ marginBottom: 'rem' }}>
            AIの力で<span className={classes.info}>テーマ</span>投資と<span className={classes.info}>ファクター</span>投資を融合
            </h3>}

            <ThematicDescription />
          <div className={!isMobile && classes.container}>
            <StructuralThemesComponent />
          </div>
        </div>
          
        <div className={classes.container}>
            <FactorDescription />
            </div>
          </div> */}
        
        {/* <SectionBanner /> */}
        {/* <Container maxWidth='lg'>
          <SectionAboutUs />
        </Container> */}
        {/* <SectionServices /> */}

        {/* <SectionNews /> */}
        {/* <SectionContactUs /> */}

        {/* {!is_production && <GridContainer>
          <GridItem style={{ padding: '3rem' }}>
            <div className={classes.section}>
              <div style={{ textAlign: 'left' }}>
                <h5 className={classes.textLeft}>
                  <i>
                    Actelligent (U.K.) Company Limited, along with its subsidiaries, Actelligent (Scotland) Company Limited, Actelligent Capital Management Limited and Actelligent Company Limited, operates a fintech platform involved with AI and Big Data technologies.
                  </i>
                </h5>
              </div>
            </div>
          </GridItem>
        </GridContainer>} */}
      </div>
    </div>
  );
}

export default withStyles(styles)(LandingPage);
